import { makeStyles } from '../../../styles';
export const useStyles = makeStyles((theme) => ({
    root: {},
    title: (props) => {
        if (props.headerMedia) {
            return {};
        }
        return {
            paddingTop: theme.spacing(5.5),
        };
    },
    content: {
        paddingBottom: theme.spacing(5.5),
    },
    actions: {},
    headerMedia: {
        paddingTop: theme.spacing(8.5),
    },
}));
//# sourceMappingURL=ConfirmationDialog.styles.js.map